export const exp_inventories = [455691, 455695];
